module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="league-data">\n	<div class="league-info">\n		<picture>\n			<source srcset="'+
((__t=( avatar ))==null?'':_.escape(__t))+
'" class="js-display-img" type="image/png">\n			<img src="/assets/images/test-avatar.png?v=1" alt="League avatar">\n		</picture>\n		<p class="league-name">'+
((__t=( name ))==null?'':_.escape(__t))+
'</p>\n	</div>\n	<select class="base-select js-change-round">\n		<option value="">All Rounds</option>\n		';
 _.each(rounds, function(round) { 
__p+='\n			';
 if(start_round <= round.id) { 
__p+='\n				<option value="'+
((__t=( round.id ))==null?'':_.escape(__t))+
'" '+
((__t=( (selected_round == round.id) ? 'selected' : '' ))==null?'':_.escape(__t))+
'>\n					Round '+
((__t=( round.id ))==null?'':_.escape(__t))+
'\n				</option>\n			';
 } 
__p+='\n		';
 }) 
__p+='\n	</select>\n	<div class="your-rank">\n		<p>Your Rank</p>\n		<strong>'+
((__t=( team_rank))==null?'':_.escape(__t))+
'/'+
((__t=( num_teams ))==null?'':_.escape(__t))+
'</strong>\n	</div>\n</div>\n<div class="table-select">\n	<a class="js-change-ladder" data-type="'+
((__t=( ( type == 'open' ) ? 'open' : 'h2h' ))==null?'':_.escape(__t))+
'" >\n		'+
((__t=( ( type == 'open' ) ? 'Open' : 'H2H' ))==null?'':_.escape(__t))+
' Ladder\n	</a>\n	<a class="active js-change-ladder" data-type="overall">Overall Points Ladder</a>\n</div>\n<div class="table-header">\n	<div class="table-item name hidden-desktop">Team/Coach</div>\n	<div class="table-item rank-item hidden-mobile">Rank</div>\n	<div class="table-item name hidden-mobile">Team Name</div>\n	<div class="table-item avatar hidden-mobile"></div>\n	<div class="table-item coach hidden-mobile">Coach</div>\n	<div class="table-item">Total Points</div>\n	<div class="table-item hidden-mobile">Round '+
((__t=( current_round ))==null?'':_.escape(__t))+
' Points</div>\n	<div class="table-item hidden-mobile">%AVG Points/Round</div>\n	<div class="table-item">Team Value</div>\n	<div class="table-item arrow">View Team</div>\n</div>';
}
return __p;
};
